module.exports = __webpack_public_path__ + "img/Mockup2@2x.89f8730f.png";